import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import {Grid} from "@mui/material";
import {SendReportForm} from "Components/Report Sending/SendReportForm";

export const EmailPopup = ({isShowModal, setIsShowModal}) => {
    return (
        <Modal className="modal show"
            backdrop="static"
            onHide={() => setIsShowModal(false)}
            show={isShowModal}
            centered={true}
            container={document.querySelector("#root .sc-bbSYpP")}
        >
            <Modal.Header closeButton={true}>
                <h5>Send Report</h5>
            </Modal.Header>
            <Modal.Body>
                <Grid container={true} spacing={2}>
                    <SendReportForm onSent={() => setIsShowModal(false)} />
                </Grid>
            </Modal.Body>
        </Modal>
    );
};

EmailPopup.propTypes = {
    isShowModal: PropTypes.bool.isRequired,
    setIsShowModal: PropTypes.func.isRequired,
};
